import RoundedCard from "@cle/components/RoundedCard";

const CourseCertificateDocumentSkeleton = () => {
  return (
    <div className="cle-course-certificate-document">
      <span className="visually-hidden">Indlæser kursusbevis</span>
      <div className="row g-4 align-items-start">
        <div className="col-12 col-xl-6">
          <RoundedCard
            className="cle-course-certificate-document__preview-card h-100"
            header="Uploadet dokument"
          >
            <div className="cle-course-certificate-document__viewer">
              <div className="cle-course-certificate-document__viewer-toolbar placeholder-glow">
                <span className="placeholder col-1 rounded" />
                <span className="placeholder col-1 rounded" />
                <span className="placeholder col-2 rounded ms-auto" />
              </div>
              <div className="cle-course-certificate-document__pdf-wrap">
                <div className="placeholder-glow w-100">
                  <span className="placeholder cle-course-certificate-document__pdf-placeholder rounded" />
                </div>
              </div>
            </div>
          </RoundedCard>
        </div>
        <div className="col-12 col-xl-6">
          <div className="d-flex flex-column gap-4">
            <RoundedCard
              className="cle-course-certificate-document__side-card"
              header="Information"
            >
              <div className="placeholder-glow">
                <span className="placeholder col-4 rounded mb-2 d-block" />
                <span className="placeholder col-8 rounded mb-3 d-block" />
                <span className="placeholder col-3 rounded mb-2 d-block" />
                <span className="placeholder col-5 rounded mb-3 d-block" />
                <span className="placeholder col-4 rounded mb-2 d-block" />
                <span className="placeholder col-6 rounded d-block" />
              </div>
            </RoundedCard>
            <RoundedCard
              className="cle-course-certificate-document__side-card"
              header="Validering"
            >
              <div className="cle-course-certificate-document__validation-grid placeholder-glow">
                {Array.from({ length: 6 }).map((_, index) => (
                  <div key={index}>
                    <span className="placeholder col-5 rounded mb-2 d-block" />
                    <span className="placeholder col-8 rounded d-block" />
                  </div>
                ))}
              </div>
            </RoundedCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCertificateDocumentSkeleton;
